module.exports = __webpack_public_path__ + "static/cthd-afc2f2c7bf52bd0682dc634f8cd37120.jpg";